var path = 'areas/projects/action-template-fields/field-Sensitive.html';
var html = "<div> <sensitive-input model=vm.value></sensitive-input> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/action-template-fields/field-Sensitive.html
// module id = 103807221768563
// module chunks = 1